module.exports = __webpack_public_path__ + "img/logo.66b105af.svg";